module.exports = __webpack_public_path__ + "img/cards.6c8a71a4.svg";